import { FC } from "react";

import Icon from "@/components/ui/Icon/Icon";
import { BentoTextElementProps } from "@/types";

const TiledText: FC<BentoTextElementProps> = ({ entry }) => {
  return (
    <div className="bg-gray-7 p-m flex flex-col justify-between rounded-lg aspect-square col-span-1 h-full md:h-full">
      {entry.icon?.link?.icon && <Icon name={entry.icon.link.icon} size="32" className="stroke-black" />}

      <div className="">
        <p className="font-medium font-secondary text-m leading-5">{entry.title}</p>
        <p className="font-normal font-secondary text-m leading-5 pt-m">{entry.text}</p>
      </div>
    </div>
  );
};
export default TiledText;
